"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerComment_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LedgerCommentType_1 = require("./LedgerCommentType");
var User_1 = require("./User");
var Location_1 = require("./Location");
var Patient_1 = require("./Patient");
var LedgerComment_Factory = /** @class */ (function () {
    function LedgerComment_Factory() {
    }
    LedgerComment_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Comment: model.Comment,
            CommentType: LedgerCommentType_1.LedgerCommentType_Factory.CreateIncoming(model.CommentType),
            CommentTypeCode: model.CommentTypeCode,
            CreatedByUser: User_1.User_Factory.CreateIncoming(model.CreatedByUser),
            CreatedByUserId: model.CreatedByUserId,
            Date: Date_Factory_1.Date_Factory.CreateIncoming(model.Date, { ignoreTimePortion: true }),
            IncludeOnStatement: model.IncludeOnStatement,
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    LedgerComment_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Comment: model.Comment,
            CommentType: LedgerCommentType_1.LedgerCommentType_Factory.CreateOutgoing(model.CommentType),
            CommentTypeCode: model.CommentTypeCode,
            CreatedByUser: User_1.User_Factory.CreateOutgoing(model.CreatedByUser),
            CreatedByUserId: model.CreatedByUserId,
            Date: Date_Factory_1.Date_Factory.CreateOutgoing(model.Date, { ignoreTimePortion: true }),
            IncludeOnStatement: model.IncludeOnStatement,
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return LedgerComment_Factory;
}());
exports.LedgerComment_Factory = LedgerComment_Factory;
